import React from "react";
import { Grid } from "@material-ui/core";
import { FileInput, SelectInput, TextInput, required } from "react-admin";

import { AttachFileIcon } from "../../../../components/common/iconography";
import { FileField } from "../../../../components/common/FileField";
import {
  ACCEPTED_FILES,
  CarrierTypes,
  MAX_FILES,
} from "../../../../utils/constants";
import { handleFileChange } from "../../../../utils/fileUtils";
import { handleCommodityChange } from "../InboundUtils";
import { AccountDropDown } from "../../../../components/common/AccountDropDown";

const validateRequired = required();

export const AdviceProcessingEditForm = ({
  form,
  notify,
  yardCommodities,
  area,
  setAreas,
  setYardCommodity,
  isBrokeredAccount,
  record,
  handleCarrierTypeChange,
}) => {
  const isBrokered = isBrokeredAccount(record.account);

  const loadTypeInput = (
    <SelectInput
      source="reloadYardCommodityId"
      label="Load Type"
      variant="outlined"
      fullWidth
      choices={yardCommodities}
      optionText={(choice) => `${choice.commodity.name} - ${choice.units}`}
      optionValue="id"
      validate={validateRequired}
      disabled={true}
      onChange={(event) =>
        handleCommodityChange(event, form, setYardCommodity, area, setAreas)
      }
      helperText={false}
    />
  );

  return (
    <Grid container spacing={2}>
      <Grid item container xs={12} spacing={1}>
        <Grid item xs={12} md={6}>
          <TextInput
            source="accountName"
            label="Account"
            variant="outlined"
            disabled
            fullWidth
            helperText={false}
          />
        </Grid>
        {isBrokered && (
          <Grid item xs={12} md={6}>
            <AccountDropDown
              source="billToAccountId"
              label="Billing Account"
              validate={validateRequired}
              allowEmpty={false}
              disabled={true}
              helperText={false}
            />
          </Grid>
        )}
        {!isBrokered && (
          <Grid item xs={12} md={6}>
            {loadTypeInput}
          </Grid>
        )}
      </Grid>
      <Grid item container xs={12} spacing={1}>
        {isBrokered && (
          <Grid item xs={12} md={6}>
            {loadTypeInput}
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <SelectInput
            source="carrierType"
            label="Carrier Type"
            variant="outlined"
            fullWidth
            disabled={true}
            choices={CarrierTypes}
            onChange={handleCarrierTypeChange}
            validate={validateRequired}
            helperText={false}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <FileInput
          source="attachments"
          label="ATTACHMENTS"
          variant="outlined"
          fullWidth
          disabled={true}
          placeholder={
            <p>
              <AttachFileIcon fontSize="large" /> <br /> Drop files to upload,
              or click to select.
            </p>
          }
          accept={ACCEPTED_FILES}
          multiple
          maxFiles={MAX_FILES}
          options={{ maxFiles: MAX_FILES }}
          onChange={(value) =>
            handleFileChange("attachments", value, form, notify)
          }
        >
          <FileField
            source="src"
            title="title"
            target="_blank"
            disabled={true}
          />
        </FileInput>
      </Grid>
    </Grid>
  );
};
